import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import Message from '../message/';
import Keyboard from '../keyboard/keyboardInput';

const PASSWORD = [1,2,3];
const LABELS = {
	1: 'CURRENT_PASSWORD',
	2: 'NEW_PASSWORD',
	3: 'REPEAT_NEW_PASSWORD'
}

@inject('accountStore', 'dictStore')
@observer
export default class ChangePassModal extends Component {

	handleSubmit = (e) => {
		e.preventDefault();
		if (this.props.accountStore.AccountPage.password.pass1.toString().length < 3) {
			this.props.accountStore.AccountPage.setError('INCORRECT_CURRENT_PASSWORD');
			document.getElementById('inputPassword1').focus();
		} else if (this.props.accountStore.AccountPage.password.pass2.toString().length < 3) {
			this.props.accountStore.AccountPage.setError('INCORRECT_NEW_PASSWORD');
			document.getElementById('inputPassword2').focus();
		} else if (this.props.accountStore.AccountPage.password.pass2 != this.props.accountStore.AccountPage.password.pass3 ) {
			this.props.accountStore.AccountPage.setError('NEW_PASSWORDS_NOT_MATCH');
			document.getElementById('inputPassword3').focus();
		} else {
			this.props.accountStore.AccountPage.savePass();
		}
	}

	render(){

		const {password, result, wait} = this.props.accountStore.AccountPage;
		const {getLang} = this.props.dictStore;
		
		return(
			result.success ? 
			<div className="change-pass_success change-pass_success_modal">{getLang(result.success)}</div>
			: <Fragment>
				<div className="account-security-data">
					<form role="form" onSubmit={this.handleSubmit}>
					  {
					  	PASSWORD.map(id => 
					  		<InputPass id={id} key={id} password={password[`pass${id}`]}/>
					  	)
					  }
					  <div className="row row-h-space clearfix">
					  	<div className="row-label"> </div>
					    <div className="row-data row-data-button">
					      <button type="submit" className={`flat_button fl_r ${wait ? 'wait' : ''}`}>{getLang('SAVE')}</button>
					    	{ result.error ? <span className="change-pass change-pass_error fl_l">{getLang(result.error)}</span> : null}
					    </div>
					  </div>
					  <div className="row row-h-space">
					  	<div className="row-label"> </div>
					    <div className="row-data">
					      <div className="note" dangerouslySetInnerHTML={{__html: getLang('IRM_PASSWORD_DESCRIPTION')}}>
								</div>
					    </div>
					  </div>
					</form>
		    </div>
		  </Fragment>
		)
	}
}

@inject('accountStore', 'dictStore')
@observer
class InputPass extends Component {

	inputPassword = (value) => {
		this.props.accountStore.AccountPage.inputPass(value, this.props.id);
	}

	render(){
		const {id, password} = this.props;
		const {getLang} = this.props.dictStore;

		return(
			<div className="row">
		  	<div className="row-label">
		    	<label htmlFor={`inputPassword${id}`}>{getLang(LABELS[id])}:</label>
		    </div>
		    <div className="row-data row-data-input">
		      <Keyboard 
		      	onChange={this.inputPassword}
		      	value={password}
		      	type="password" 
		      	className="form-control" 
		      	maxLength="6"
		      	id={`inputPassword${id}`} 
		      	autoComplete="off"
		      	positionX="right"
            positionY="bottom"
		      />
		    </div>
		  </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/account/changePassModal.jsx